import { PayloadAction } from '@reduxjs/toolkit'
import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import { GET_RECORDED_ECG_WINDOW } from './actionTypes'
import { getRecordedEcgWindow } from './api'
import {
  addPatientRecordedEcgWindow,
  errorPatientRecordedEcgWindow,
  getRecordedEcgWindowActionType,
} from './recordedEcgWindowReducer'
import { PatientRecordedEcgWindowEntityType } from './types'

export function* handlePatientRecordedEcgWindow(
  action: PayloadAction<getRecordedEcgWindowActionType>
): SagaIterator<void> {
  try {
    const response = yield call(
      getRecordedEcgWindow,
      action.payload.patientKey,
      action.payload.startTime,
      action.payload.endTime
    )
    const { data } = response
    const modifiedData: PatientRecordedEcgWindowEntityType = {
      key: action.payload.patientKey,
      patientRecordedEcgWindow: data.data,
    }
    yield put(addPatientRecordedEcgWindow(modifiedData))
  } catch (error: any) {
    const errorMessage =
      error.response?.Ecg?.message || error.message || 'Unknown error'
    yield put(errorPatientRecordedEcgWindow(errorMessage))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_RECORDED_ECG_WINDOW, handlePatientRecordedEcgWindow)
}

export const recordedEcgWindowSaga = [fork(watcherSaga)]
